import { DEFAULT_COLOR } from '../constants/defaultColor'
import { DEFAULT_FONT } from '../constants/defaultFont'
import { ZervantTemplateSettings } from '../types/templates/zervantTemplateSettings'
import { ZervantTemplateSettingsArea } from '../types/templates/zervantTemplateSettingsArea'

export interface GetCustomTemplateSettingsPayloadProps {
  shouldApplyTemplateColorToTotal: boolean
  shouldApplyTemplateColorToHeader: boolean
  shouldApplyTemplateColorToColumnHeaders: boolean
  shouldApplyTemplateColorToDividers: boolean
  templateColor?: string
  templateFont?: string
}

export const getCustomTemplateSettingsPayload = ({
  shouldApplyTemplateColorToTotal,
  shouldApplyTemplateColorToHeader,
  shouldApplyTemplateColorToColumnHeaders,
  shouldApplyTemplateColorToDividers,
  templateColor,
  templateFont,
}: GetCustomTemplateSettingsPayloadProps): ZervantTemplateSettings => {
  const areas: ZervantTemplateSettingsArea[] = (
    [
      [shouldApplyTemplateColorToTotal, 'total'],
      [shouldApplyTemplateColorToHeader, 'header'],
      [shouldApplyTemplateColorToColumnHeaders, 'columnHeaders'],
      [shouldApplyTemplateColorToDividers, 'dividers'],
    ] as const
  )
    .filter(([shouldApply]) => shouldApply)
    .map(([, area]) => area)

  return {
    areas,
    color: { text: templateColor || DEFAULT_COLOR },
    font: templateFont || DEFAULT_FONT,
    invoiceHeaderLines: 'background',
  }
}
